// identifying user role by role number

export const isMasterRole = (role) => Number(role) === 1;

export const isGroupAdminRole = (role) => Number(role) === 2;

export const isSubgroupAdminRole = (role) => Number(role) === 3;

export const isAdminRole = (role) => Number(role) > 0 && Number(role) < 4;
